import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["container", "button", "label", "mapIcon", "listIcon"];

  static values = {
    showingMap: { type: Boolean, default: false },
    mapLabel: { type: String, default: "Carte" },
    listLabel: { type: String, default: "Liste" },
  };

  connect() {
    this.listScrollY = null;
  }

  toggle() {
    const nextShowingMap = !this.showingMapValue;

    if (nextShowingMap) {
      this.listScrollY = window.scrollY;
      this.#scrollToResultsTop();
    }

    this.showingMapValue = !this.showingMapValue;
    this.containerTarget.classList.toggle("show-map", this.showingMapValue);

    // Update button label and icons visibility
    if (this.showingMapValue) {
      this.labelTarget.textContent = this.listLabelValue;
      this.mapIconTarget.classList.add("hidden");
      this.listIconTarget.classList.remove("hidden");
    } else {
      this.labelTarget.textContent = this.mapLabelValue;
      this.mapIconTarget.classList.remove("hidden");
      this.listIconTarget.classList.add("hidden");
    }

    // Trigger map resize when showing map (needed for Mapbox)
    if (this.showingMapValue) {
      window.dispatchEvent(new Event("resize"));
    } else if (this.listScrollY !== null) {
      window.scrollTo({ top: this.listScrollY, behavior: "auto" });
      this.listScrollY = null;
    }
  }

  #scrollToResultsTop() {
    const top =
      this.containerTarget.getBoundingClientRect().top + window.scrollY;

    window.scrollTo({ top, behavior: "auto" });
  }
}
